import { OptionFormTypes } from '../../../../../services/filtering/filter-form-render-service/option-form-types';
import { id } from '../../../../../filters/options/delivery-status/index';

export default {
  id,
  type: OptionFormTypes.TYPE_ORDER_COLLECTION_FILTER,
  filterValue: 'DeliveryStatus',
  expectsArgumentAsArray: true,
};
